import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class BonogesService {
  headers: HttpHeaders = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService
  ) { }

  async getEventosGes(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/BonoGes/ObtenerEventosGes`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getBeneficiarios(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/BonoGes/GesBeneficiariosActivos`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }


  async getCentroMedicos(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/BonoGes/ObtenerCentrosMedicosGes`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async getCanastaGes(folio) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/BonoGes/ObtenerCanastaGes?eventoGes=${folio}`;

    try {
      return await this.httpClient.get(url, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async valorizarBono(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/BonoGes/ValorizacionGes`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async grabarBonoGes(data) {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/BonoGes/GrabarBonoGes`;

    try {
      return await this.httpClient.post(url, data, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }
}
